<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<DefaultPropertyInput
			ref="richEditor"
			@focus="onInputFocus"
			@click="() => onInputClick(true)"
			@open="openDataInputMenu"
			@blur="onInputBlur"
			@content-updated="onContentUpdate"
			v-model="localValue"
			:textAreaMode="isTextArea"
			:inputFieldHint="param.placeholder"
			:multipleSelection="allowMultipleSelection"
			:isFocused="isFocused"
			:readonly="readonly"
			:showDataMenu="showDataMenu"
		/>
		<template #input-data>
			<DefaultDataInputMenu :param="param" v-on="dataInputListeners" ref="data-input-menu" />
		</template>
	</ParamWrapper>
</template>

<script>
import ParamTypeMixin from './mixins/ParamTypeMixin';
import IsTextAreaMixin from './mixins/ParamPropertiesMixins/IsTextAreaMixin';
import ParamTypeExtenderDataInputMenuMixin from './mixins/ParamTypeExtenderDataInputMenuMixin';
import DefaultPropertyInput from '../inputsComponents/DefaultPropertyInput';
import ThisFlowMixin from './mixins/ThisFlowMixin';
import DefaultDataInputMenu from '../DataInputMenus/DefaultDataInputMenu';
export default {
	name: 'DefaultParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin, IsTextAreaMixin],
	components: { DefaultPropertyInput, DefaultDataInputMenu },
	mounted() {
		this.$nextTick(() => {
			this.setInputElement(this.$refs['richEditor']?.$el);
		});
	},
};
</script>
<style lang="scss" scoped></style>
